module.exports = __webpack_public_path__ + "static/media/course_operation.6746acb4.png";